import React, { useState, useEffect } from 'react';
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
} from '@mui/icons-material';

import WebsitePageWrapper from './WebsitePageWrapper';

const WebsiteSocialPage = ({ userOrganizationId }) => {
  return (
    <WebsitePageWrapper
      title="Social Links"
      subtitle="Connect your social media profiles"
      userOrganizationId={userOrganizationId}
    >
      {SocialContent}
    </WebsitePageWrapper>
  );
};

const SocialContent = ({ website, updateWebsite, isSaving }) => {
  const [facebook, setFacebook] = useState(website?.social?.facebook || '');
  const [instagram, setInstagram] = useState(website?.social?.instagram || '');
  const [twitter, setTwitter] = useState(website?.social?.twitter || '');

  useEffect(() => {
    setFacebook(website?.social?.facebook || '');
    setInstagram(website?.social?.instagram || '');
    setTwitter(website?.social?.twitter || '');
  }, [website]);

  const handleSave = async () => {
    await updateWebsite({
      social: {
        facebook,
        instagram,
        twitter,
      },
    });
  };

  const hasLinks = facebook || instagram || twitter;

  return (
    <>
      <div className="website-page-content">
        <div className="website-card">
          <div className="website-card-header">
            <h2 className="website-card-title">Social Media Links</h2>
            <p className="website-card-subtitle">
              Add your social media profile URLs. These will be displayed on your public website.
            </p>
          </div>

          <div className="website-card-body">
            {/* Facebook */}
            <div className="website-form-group">
              <label className="website-form-label">Facebook</label>
              <div className="website-social-input">
                <div className="website-social-icon facebook">
                  <FacebookIcon />
                </div>
                <input
                  type="url"
                  value={facebook}
                  onChange={(e) => setFacebook(e.target.value)}
                  placeholder="https://facebook.com/yourpage"
                  className="website-form-input"
                />
              </div>
            </div>

            {/* Instagram */}
            <div className="website-form-group">
              <label className="website-form-label">Instagram</label>
              <div className="website-social-input">
                <div className="website-social-icon instagram">
                  <InstagramIcon />
                </div>
                <input
                  type="url"
                  value={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                  placeholder="https://instagram.com/yourprofile"
                  className="website-form-input"
                />
              </div>
            </div>

            {/* Twitter */}
            <div className="website-form-group">
              <label className="website-form-label">Twitter</label>
              <div className="website-social-input">
                <div className="website-social-icon twitter">
                  <TwitterIcon />
                </div>
                <input
                  type="url"
                  value={twitter}
                  onChange={(e) => setTwitter(e.target.value)}
                  placeholder="https://twitter.com/yourhandle"
                  className="website-form-input"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Preview Section */}
        <div className="website-card">
          <div className="website-card-header">
            <h2 className="website-card-title">Preview</h2>
            <p className="website-card-subtitle">
              Social media icons will appear in your website footer
            </p>
          </div>

          <div className="website-card-body">
            <div className="website-social-preview">
              <h4>Follow Us</h4>
              <div className="website-social-preview-icons">
                {facebook && (
                  <a
                    href={facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="website-social-preview-icon facebook"
                  >
                    <FacebookIcon />
                  </a>
                )}
                {instagram && (
                  <a
                    href={instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="website-social-preview-icon instagram"
                  >
                    <InstagramIcon />
                  </a>
                )}
                {twitter && (
                  <a
                    href={twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="website-social-preview-icon twitter"
                  >
                    <TwitterIcon />
                  </a>
                )}
                {!hasLinks && (
                  <p className="website-social-preview-empty">No social links added yet</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Action Bar */}
      <div className="website-action-bar">
        <button className="action-btn primary" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Social Links'}
        </button>
      </div>
    </>
  );
};

export default WebsiteSocialPage;
